import { z } from 'zod';

export const baseEntitySchema = z.object({
  id: z.string(),
  createdAt: z.date().nullable(),
  updatedAt: z.date().nullable(),
});

export type BaseEntity = z.infer<typeof baseEntitySchema>;
